export const SET_ALL_DOCUMENTS = "Setzt die Dokuments einer Lieferung im Store";
export const UPDATE_DOCUMENTS_FOR_SECTION =
  "Entfernt alle Dokumente einer Sektion und hängt sie hinten in der richtigen Reihenfolge dran";
export const UPLOAD_INTO_POSITION = "Fügt einen Ladebalken ein";
export const REMOVE_FROM_POSITION = "Entfernt den Ladebalken";
